import { z } from "zod";
export const MomentOutcome = z.enum(["acted", "dismissed", "expired"]);
export const MomentOutcomeRequest = z.object({ outcome: MomentOutcome });
export const MomentSeenResponse = z.object({ ok: z.boolean() });
export const MomentOutcomeResponse = z.object({ ok: z.boolean() });
//# sourceMappingURL=moments.js.map